// M6 Warranty — data-testid registry.
export const WARR = {
  navWarranties: "nav-warranties",

  listTable: "warranties-table",
  listRow: (id) => `warranty-row-${id}`,
  searchInput: "warranty-search-input",
  statusFilter: "warranty-status-filter",
  typeFilter: "warranty-type-filter",
  pagePrev: "warranty-page-prev",
  pageNext: "warranty-page-next",

  detailHeader: "warranty-detail-header",
  detailStatus: "warranty-detail-status",
  detailType: "warranty-detail-type",
  detailPlan: "warranty-detail-plan",
  detailPeriod: "warranty-detail-period",

  certificateBtn: "warranty-certificate-btn",
  certificateDownload: "warranty-certificate-download",
  renewBtn: "warranty-renew-btn",
  renewPlan: "warranty-renew-plan",
  renewAmount: "warranty-renew-amount",
  renewSubmit: "warranty-renew-submit",
  voidBtn: "warranty-void-btn",
  voidReason: "warranty-void-reason",
  voidSubmit: "warranty-void-submit",

  historyTable: "warranty-history-table",
  historyRow: (id) => `warranty-history-row-${id}`,
};
